import ApiService from '../../../shared/services/api-service';
import commonActionCreators from '../../../shared/store/common/action-creators';
import dashboardCommitTypes from './commit-types';

const dashboardActionCreators = {
  fetchOutstandingForms() {
    return async (dispatch) => {
      dispatch(this.setIsLoading('fetchOutstandingForms'));
      const data = await ApiService.get('/api/v1/observation-stats/outstanding')
        .then(response => response.data)
        .catch((error) => {
          dispatch(commonActionCreators.handleApiError(error));
          return Promise.reject();
        });
      dispatch(this.setIsLoading('fetchOutstandingForms'));
      if (data) {
        dispatch(this.setOutstandingForms(data));
      }
      return Promise.resolve();
    };
  },
  fetchDOR() {
    return async (dispatch) => {
      dispatch(this.setIsLoading('fetchDOR'));
      const data = await ApiService.get('/api/v1/dor-stats/outstanding')
        .then(response => response.data)
        .catch((error) => {
          dispatch(commonActionCreators.handleApiError(error));
          return Promise.reject();
        });
      dispatch(this.setIsLoading('fetchDOR'));
      if (data) {
        dispatch(this.setDorStats(data));
      }
      return Promise.resolve();
    };
  },
  fetchWOR() {
    return async (dispatch) => {
      dispatch(this.setIsLoading('fetchWOR'));
      const data = await ApiService.get('/api/v1/wor-stats/outstanding')
        .then(response => response.data)
        .catch((error) => {
          dispatch(commonActionCreators.handleApiError(error));
          return Promise.reject();
        });
      dispatch(this.setIsLoading('fetchWOR'));
      if (data) {
        dispatch(this.setWorStats(data));
      }
      return Promise.resolve();
    };
  },
  fetchActiveFtos() {
    return async (dispatch) => {
      dispatch(this.setIsLoading('fetchActiveFtos'));
      const data = await ApiService.get('/api/v1/fto-stats/active')
        .then(response => response.data)
        .catch((error) => {
          dispatch(commonActionCreators.handleApiError(error));
          return Promise.reject();
        });
      dispatch(this.setIsLoading('fetchActiveFtos'));
      if (data) {
        dispatch(this.setActiveFtosStats(data));
      }
      return Promise.resolve();
    };
  },
  fetchActiveOits() {
    return async (dispatch) => {
      dispatch(this.setIsLoading('fetchActiveOits'));
      const data = await ApiService.get('/api/v1/oit-stats/active')
        .then(response => response.data)
        .catch((error) => {
          dispatch(commonActionCreators.handleApiError(error));
          return Promise.reject();
        });
      dispatch(this.setIsLoading('fetchActiveOits'));
      if (data) {
        dispatch(this.setActiveOitsStats(data));
      }
      return Promise.resolve();
    };
  },
  fetchOitsStatsRemedial() {
    return async (dispatch) => {
      dispatch(this.setIsLoading('fetchOitsStatsRemedial'));
      const data = await ApiService.get('/api/v1/oit-stats/remedial')
        .then(response => response.data)
        .catch((error) => {
          dispatch(commonActionCreators.handleApiError(error));
          return Promise.reject();
        });
      dispatch(this.setIsLoading('fetchOitsStatsRemedial'));
      if (data) {
        dispatch(this.setOitsRemedialsStats(data));
      }
      return Promise.resolve();
    };
  },
  fetchAssignedOits() {
    return async (dispatch) => {
      dispatch(this.setIsLoading('fetchAssignedOits'));
      const data = await ApiService.get('/api/v1/fto-stats/oits')
        .then(response => response.data)
        .catch((error) => {
          dispatch(commonActionCreators.handleApiError(error));
          return Promise.reject();
        });
      dispatch(this.setIsLoading('fetchAssignedOits'));
      if (data) {
        dispatch(this.setAssignedOits(data));
      }
      return Promise.resolve();
    };
  },
  fetchTrainingProgramStatsTotalWeeks() {
    return async (dispatch) => {
      dispatch(this.setIsLoading('fetchTrainingProgramStatsTotalWeeks'));
      const data = await ApiService.get('/api/v1/training-program-stats/total-weeks')
        .then(response => response.data)
        .catch((error) => {
          dispatch(commonActionCreators.handleApiError(error));
          return Promise.reject();
        });
      dispatch(this.setIsLoading('fetchTrainingProgramStatsTotalWeeks'));
      if (data) {
        dispatch(this.setTrainingProgramsStatsTotalWeeks(data));
      }
      return Promise.resolve();
    };
  },
  fetchRiskAlertStats() {
    return async (dispatch) => {
      dispatch(this.setIsLoading('fetchRiskAlertStats'));
      const data = await ApiService.get('/api/v1/risk-alert-stats/last-week')
        .then(response => response.data)
        .catch((error) => {
          dispatch(commonActionCreators.handleApiError(error));
          return Promise.reject();
        });
      dispatch(this.setIsLoading('fetchRiskAlertStats'));
      if (data) {
        dispatch(this.setFetchRiskAlertStats(data));
      }
      return Promise.resolve();
    };
  },
  setDorStats(dor) {
    return {
      dor,
      type: dashboardCommitTypes.SET_DOR_STATS,
    };
  },
  setWorStats(wor) {
    return {
      wor,
      type: dashboardCommitTypes.SET_WOR_STATS,
    };
  },
  setActiveFtosStats(activeFtos) {
    return {
      activeFtos,
      type: dashboardCommitTypes.SET_FTO_STATS_ACTIVE,
    };
  },
  setActiveOitsStats(activeOits) {
    return {
      activeOits,
      type: dashboardCommitTypes.SET_OIT_STATS_ACTIVE,
    };
  },
  setOitsRemedialsStats(oitsRemedials) {
    return {
      oitsRemedials,
      type: dashboardCommitTypes.SET_OIT_STATS_REMEDIAL,
    };
  },

  setOutstandingForms(outstandingForms) {
    return {
      outstandingForms: outstandingForms
        .map(form => form.count)
        .reduce((acc, count) => acc + count, 0),
      type: dashboardCommitTypes.SET_OUTSTANDING_FORMS,
    };
  },
  setAssignedOits(assignedOits) {
    return {
      assignedOits,
      type: dashboardCommitTypes.SET_ASSIGNED_OITS,
    };
  },
  setTrainingProgramsStatsTotalWeeks(totalWeeks) {
    return {
      totalWeeks,
      type: dashboardCommitTypes.SET_TRAINING_PROGRAMS_STATS_TOTAL_WEEKS,
    };
  },
  setFetchRiskAlertStats(riskAlerts) {
    return {
      riskAlerts,
      type: dashboardCommitTypes.SET_RISK_ALERTS_STATS,
    };
  },
  setIsLoading(isLoading) {
    return {
      isLoading,
      type: dashboardCommitTypes.SET_DASHBOARD_IS_LOADING,
    };
  },
};

export default dashboardActionCreators;
